import { UUID } from "@bitory-gmbh/nidavellir";

export const htzSummaryBaseDataKey = "htz.summary.baseData";

export interface SummaryBaseData {
  id: UUID;
  companyId: UUID;
  label: string;
  createdAt: string;
  updatedAt: string;
  title: string;
  subtitle: string;
  coverLetter: string;
}
